import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const SignUpFooter = () => (
  <div
    className='page bg-gray-100 ps-container-lg-margin ps-container-fixed text-center'
    style={{ paddingTop: '60px', marginTop: '64px' }}
  >
    <p className='text-gray-600 text-small'>
      <FormattedMessage
        id='referrals.sign_up_footer.sign_up'
        defaultMessage='Sign up with Peerspace to claim your discount. Your discount will be applied when you book a space in the US for {value} or more. Discounts expire 1 year after signing up.'
        values={{
          value: (
            <FormattedNumber
              value={150}
              currency='USD'
              style='currency'
              minimumFractionDigits={0 === 150 % 1 ? 0 : 2}
              maximumFractionDigits={0 === 150 % 1 ? 0 : 2}
            />
          )
        }}
      />
    </p>
  </div>
);

export default SignUpFooter;
